import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { formatPlaceName } from '@aviv_price-pages/brand';
import { Box, useBreakpointValue } from '@gemini/core';
import { Link } from '@gemini/ui';
import BoxLinkHoverable from '@/components/BoxLinkHoverable/BoxLinkHoverable';
import { Seo } from '@/components/Seo/Seo';
import { usePageLayoutContext } from '@/hooks/usePageLayoutContext/usePageLayoutContext';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
const CityStreetsPage = () => {
    const { pricePageProps: { pricePageContext, allStreets }, } = usePageLayoutContext();
    const { t } = useShellTranslation();
    const alphabetNav = useMemo(() => Array.from({ length: 26 }, (_, i) => String.fromCharCode('A'.charCodeAt(0) + i)).map((letter) => ({ letter, disabled: !allStreets?.[letter] })), [allStreets]);
    const colNumber = useBreakpointValue({
        base: 2,
        sm: 3,
        lg: 4,
    });
    const margingHorizontal = useBreakpointValue({
        base: 'spacing.16',
        xs: 'spacing.32',
        xl: 'spacing.64',
        xxl: 'spacing.80',
    });
    return (_jsxs(_Fragment, { children: [_jsx(Seo, { pricePageContext: pricePageContext, i18nkey: "links_city", isStreetListPage: true }), _jsxs(Box, { textAlign: "center", children: [_jsx(Box, { as: "h1", children: t('page_h1.links_city', {
                            replace: {
                                place: formatPlaceName(pricePageContext.place),
                            },
                        }) }), _jsx(Box, { display: "flex", marginVertical: "spacing.32", gap: "spacing.4", alignItems: "center", justifyContent: "center", flexWrap: "wrap", marginHorizontal: margingHorizontal, children: alphabetNav.map(({ letter, disabled }, key) => (_jsx(Box, { width: "20px", marginHorizontal: "spacing.2", children: _jsx(BoxLinkHoverable, { letter: letter, disabled: disabled }) }, key))) })] }), _jsx(Box, { children: Object.entries(allStreets ?? {}).map(([letter, streets], key) => (_jsxs(Box, { marginTop: "spacing.32", children: [_jsx(Box, { as: "h2", id: letter, marginHorizontal: margingHorizontal, children: letter }), _jsx(Box, { unsafe_style: {
                                columnCount: colNumber,
                                columnGap: '16px',
                                columnFill: 'balance',
                            }, marginHorizontal: margingHorizontal, children: streets.map((street, key) => (_jsxs(Link, { href: street.url, marginVertical: "spacing.4", children: [street.placeName, ' ', street.placePrefix ? `(${street.placePrefix})` : ''] }, key))) })] }, key))) })] }));
};
export default CityStreetsPage;
